import axios from 'axios'
import {
  httpInstance,
  pictureUploadInstance
} from '../../api'
import * as types from '../mutation-types'
import router from '../../router'

const state = {
  users: [],
  activeUser: {},
  err: false,
  isPasswordReset: false,
  errMessage: ''
}

const getters = {
  getActiveUser: state => state.activeUser,
  getToken: state => state.activeUser.token,
  getErr: state => state.err,
  getErrMessage: state => state.errMessage
}

const mutations = {
  [types.SET_USER](state, payload) {
    Object.assign(state.activeUser, payload)
  },

  [types.SIGN_OUT](state) {
    state.activeUser = {}
  },

  [types.SET_ERR](state, payload) {
    state.err = payload
  },

  [types.SET_PASSWORD_RESET_FLAG](state, payload) {
    state.isPasswordReset = payload
  },

  [types.SET_ERR_MESSAGE](state, payload) {
    state.errMessage = payload
  },

  [types.CHANGE_USER_PROFILE](state, payload) {
    state.activeUser = payload
  },

  [types.CHANGE_USER_PICTURE](state, payload) {
    state.activeUser.small_photo = payload.small_photo
    state.activeUser.normal_photo = payload.normal_photo
  }
}

const actions = {
  async signIn({
    commit,
    dispatch,
    state
  }, payload) {
    commit(types.SET_LOADING, true)
    commit(types.SET_ERR, false)
    await httpInstance
      .post('/auth/login', {
        employee_id: payload.user.employee_id,
        password: payload.user.password
      })
      .then(response => {
        commit(types.SET_ERR, false)
        commit(types.LOAD_RESPONSE, response)
        dispatch('setActiveUser', response.data)
        commit(types.GET_ALL_MENU_ITEMS, response.data.menus)
        localStorage.setItem('accesstoken', response.data.token)
        axios.defaults.headers.common['accesstoken'] = `Bearer ${
          response.data.token
        }`
        setTimeout(() => {
          commit(types.SET_LOADING, false)
          let redirect = payload.redirect ? payload.redirect : '/'
          router.replace(redirect)
        }, 500)
      })
      .catch(error => {
        console.log(error.response)
        commit(types.LOAD_RESPONSE, error.response)
        setTimeout(() => {
          commit(types.SET_LOADING, false)
          commit(types.SET_ERR, true)
        }, 500)
      })
  },

  setActiveUser({
    commit
  }, payload) {
    commit(types.SET_USER, payload)
  },

  signOut({
    commit
  }) {
    commit(types.SIGN_OUT)
    localStorage.removeItem('accesstoken')
    commit(types.SET_LOADING, false)
    router.replace('/signin')
  },

  async changeUserProfile({
    commit,
    state
  }, payload) {
    commit(types.SET_LOADING, true)
    await httpInstance
      .put(`/auth/${payload.id}/update-profile`, {
        company_code: state.activeUser.company_code,
        employee_id: payload.employee_id,
        first_name: payload.firstName,
        last_name: payload.lastName,
        email: payload.email,
        phone: payload.phone
      })
      .then(response => {
        commit(types.CHANGE_USER_PROFILE, response.data)
        commit(types.LOAD_RESPONSE, response)
        commit(types.SET_LOADING, false)
      })
      .catch(error => {
        console.log(error.response)
        commit(types.LOAD_RESPONSE, error.response)
        commit(types.SET_LOADING, false)
      })
  },

  async changePassword({
    commit
  }, payload) {
    commit(types.SET_LOADING, true)
    await httpInstance
      .post('/auth/change-password', {
        old_password: payload.old_password,
        new_password: payload.new_password,
        retype_password: payload.retype_password
      })
      .then(response => {
        commit(types.LOAD_RESPONSE, response)
        commit(types.SET_LOADING, false)
      })
      .catch(error => {
        console.log(error.response)
        commit(types.LOAD_RESPONSE, error.response)
        commit(types.SET_LOADING, false)
      })
  },

  async uploadPicture({
    commit
  }, payload) {
    commit(types.SET_LOADING, true)
    const formData = new FormData()
    formData.append(payload.name, payload.file)
    await pictureUploadInstance
      .post('user/photo', formData)
      .then(response => {
        commit(types.SET_USER, {
          normal_photo: response.data.file_path
        })
        commit(types.LOAD_RESPONSE, response)
        commit(types.SET_LOADING, false)
      })
      .catch(error => {
        console.log(error.response)
        commit(types.LOAD_RESPONSE, error.response)
        commit(types.SET_LOADING, false)
      })
  },

  async uploadApp({
    commit
  }, payload) {
    commit(types.SET_LOADING, true)
    const formData = new FormData()
    formData.append('file', payload)
    await pictureUploadInstance
      .post('/upload', formData)
      .then(response => {
        commit(types.LOAD_RESPONSE, response)
        commit(types.SET_LOADING, false)
      })
      .catch(error => {
        commit(types.LOAD_RESPONSE, error.response)
        commit(types.SET_LOADING, false)
      })
  },

  async sendForgotPassCode({
    commit
  }, payload) {
    commit(types.SET_LOADING, true)
    await httpInstance
      .post('auth/email-confirm-reset-password', payload)
      .then(response => {
        commit(types.LOAD_RESPONSE, response)
        commit(types.SET_LOADING, false)
        commit(types.SET_PASSWORD_RESET_FLAG, true)
      })
      .catch(error => {
        console.log(error.response)
        commit(types.LOAD_RESPONSE, error.response)
        commit(types.SET_LOADING, false)
      })
  },

  async resetPasswordWithCode({
    commit
  }, payload) {
    commit(types.SET_LOADING, true)
    await httpInstance
      .post('auth/confirm-code/reset-password', payload)
      .then(response => {
        commit(types.LOAD_RESPONSE, response)
        commit(types.SET_LOADING, false)
        commit(types.SET_PASSWORD_RESET_FLAG, false)
      })
      .catch(error => {
        console.log(error.response)
        commit(types.LOAD_RESPONSE, error.response)
        commit(types.SET_LOADING, false)
      })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/users.js